import styled from 'styled-components';

export const InputContainer = styled.div`
  input.formInput {
    margin-right: 0.5rem;
    cursor: pointer;
  }
`;